import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { formBtn2, inputClass, labelClass } from "../Utils/CustomClasses";
import { validateEmail } from "../Utils/Validation";
import Error from "../Error/Error";
import { useForm } from "react-hook-form";
import { ConfirmPasswordAPI, ForgotPasswordAPI } from "../../API/Api";
import { toast } from "react-toastify";

export default function ForgotPasswordModal({ IsOpen, setIsOpen }) {
    const { reset, register, handleSubmit, formState: { errors }, } = useForm();
    const [OtpModal, setOtpModal] = useState(false)
    const [email, setEmail] = useState("");
    const toggle = () => {
        setIsOpen(false);
        setOtpModal(false);
        setEmail("");
        reset();
    }

    const onSubmit = async (data) => {
        try {
            let response;
            if (!OtpModal) {
                const payload = {
                    email: data.email
                }
                response = await ForgotPasswordAPI(payload)
                if (response?.status === 200) {
                    toast.success(response?.data?.message)
                    setEmail(data.email);
                    reset({ otp: "" })
                    setOtpModal(true)
                } else {
                    toast.error(response?.response?.data?.error)
                }
            } else {
                const Updatedpayload = {
                    email: email,
                    otp: Number(data.otp),
                    newPassword: data.newPassword
                }
                response = await ConfirmPasswordAPI(Updatedpayload)
                if (response?.status === 200) {
                    toast.success(response?.data?.message)
                    toggle()
                } else {
                    toast.error(response?.response?.data?.error)
                }
            }
        }
        catch (err) {
            console.log('Error:', err)
        }
    }
    return (
        <>
            <Transition appear show={IsOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-scroll">
                        <div className="flex items-center justify-center min-h-full p-2 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className={`${IsOpen ? "bg-base-color-blue" : "bg-base-color"} w-full px-3 py-4 text-lg font-semibold leading-6 text-white font-tb`}
                                    >
                                        {"Forgot Password"}
                                    </Dialog.Title>

                                    <div>
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="p-4">

                                                {!OtpModal ? (<div className="grid grid-cols-1 gap-4">
                                                    <div>
                                                        <label className={labelClass}>
                                                            Email <span className="text-red-500">*</span>
                                                        </label>
                                                        <input type="email"
                                                            className={inputClass}
                                                            {...register('email', {
                                                                validate: validateEmail
                                                            })}
                                                        />
                                                        {errors.email && <Error title={errors.email.message} />}
                                                    </div>
                                                </div>) : (
                                                    <div className="flex flex-col gap-6">
                                                        <div>
                                                            <label className={labelClass}>
                                                                Enter OTP <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="text"
                                                                className={inputClass}
                                                                {...register("otp", { required: "OTP is required" })}
                                                            />
                                                            {errors.otp && <Error title={errors.otp.message} />}
                                                        </div>
                                                        <div>
                                                            <label className={labelClass}>
                                                                New Password <span className="text-red-500">*</span>
                                                            </label>
                                                            <input type="password"
                                                                className={inputClass}
                                                                {...register('newPassword', { required: "New password is required" })}
                                                            />
                                                            {errors.newPassword && <Error title={errors.newPassword.message} />}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                                <button
                                                    type="submit"
                                                    className={`${IsOpen ? "bg-base-color-blue" : "bg-base-color"} px-4 py-2 text-white font-bold rounded-lg`}
                                                >
                                                    {!OtpModal ? " Send OTP" : "Submit"}
                                                </button>

                                                <button
                                                    type="button"
                                                    className={`${IsOpen ? "bg-base-color-blue text-white" : formBtn2} px-4 py-2 font-bold rounded-lg`}
                                                    onClick={toggle}
                                                >
                                                    Close
                                                </button>

                                            </footer>
                                        </form>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
